<template>
  <div>
    <div class="search_wrap">
      <el-form
        :model="queryParam"
        ref="form"
        label-width="80px"
        :inline="true"
        size="mini"
      >
        <el-form-item label="设备编号">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.imeis"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.deviceName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <div class="selectBox">
          <span class="selectText">警告类型</span>
          <el-select v-model="queryParam.alarmType" size="mini" placeholder="请选择">
            <el-option
              v-for="item in alarmTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="selectBox">
          <span class="selectText">警告时间</span>
          <el-date-picker
            size="mini"
            v-model="warningTime"
            @change="dateChange"
            :default-value="dateDefaultShow"
            unlink-panels
            :clearable="true"
            :picker-options="expireTimeOption"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
    </e-table>
  </div>
</template>

<script>
import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";
export default {
  name: "deviceList",
  components: { eTable },
  mixins: [listMixin],
  created() {},
  mounted() {
    this.dateDefaultShow = new Date();
    this.dateDefaultShow.setMonth(new Date().getMonth() - 1);
  },
  computed: {},
  watch: {},
  data() {
    return {
      url: {
        list: "/tqAlarm/queryPage",
      },
      queryParam: {},
      alarmTypes: [
        { label: "全部", value: "" },
        { label: "SOS告警", value: "1" },
        { label: "低电告警", value: "2" },
        // { label: "拆除告警", value: "3" },
        // { label: "震动告警", value: "4" },
        // { label: "超速告警", value: "5" },
        // { label: "主电欠压告警", value: "6" },
        // { label: "主电掉电告警", value: "7" },
        // { label: "怠速告警", value: "8" },
        // { label: "非法位移报警", value: "9" },
        // { label: "离线告警", value: "offline" },
        // { label: "离开围栏告警", value: "out_fence" },
        // { label: "超速告警", value: "overspeed" },
        // { label: "停留告警", value: "stop" },
        // { label: "ACC开启告警", value: "acc_on" },
        // { label: "ACC关闭告警", value: "acc_off" },
        // { label: "进入围栏告警", value: "in_fence" },
        // { label: "停留告警", value: "stop" },
        // { label: "停留告警", value: "stop" },
        // { label: "停留告警", value: "stop" },
      ],
      warningTime: "",
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() >= Date.now();
        },
      },
      dateDefaultShow: "",
      columns: [
        {
          field: "imei",
          fixed: "left",
          label: "设备编号",
        },
        {
          field: "deviceName",
          label: "设备名称",
        },
        {
          field: "alarmMsg",
          label: "警告类型",
        },
        {
          field: "alarmTime",
          label: "警告时间",
        },
        {
          field: "updateTime",
          label: "修改时间",
        },
        {
          field: "alarmAddr",
          label: "警告地址",
        },
      ],
      // deviceList: [],
      // ipagination: {
      //   current: 1,
      //   pageSize: 10,
      //   total: 0,
      // },
    };
  },
  methods: {
    dateChange(date) {
      if (date) {
        this.queryParam.startTime = date[0];
        this.queryParam.endTime = date[1];
      } else {
        this.queryParam.startTime = "";
        this.queryParam.endTime = "";
      }
    },
    resetForm() {
      this.queryParam = {};
      this.warningTime = "";
      this.searchQuery();
    },
  },
};
</script>

<style scoped lang="less">
.search_wrap {
  margin: 10px 0;
}
.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.selectText {
  width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>
